<template>
  <div class="project-popup">
    <div class="project-wrapper" v-for="(project, index) in activeProjects" :key="index">
      <div class="background-img" :style="{ backgroundImage: `url(&quot;${project.image}&quot;)` }"></div>
      <div class="proj-content">
        <div class="proj-head">
          <div class="back-button"><a @click="goBack()">&larr; go back</a></div>
          <h1>{{ project.title }}</h1>
          <h2>{{ project.year }}</h2>
          <div class="by">
            <p>{{ project.by }}</p>
          </div>
        </div>

        <div class="sub-content">

          <a :href="`${project.video}`" target="_blank" class="placeholder">
            <iframe width="560" height="315" :src="`${project.video}`" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
            <p>&#9654; Video lädt hier!</p>
          </a>
          <div class="proj-desc">
            <p>{{ project.description }}</p>
          </div>
          <table class="rolls">
            <tr class="roll" v-for="(roll, index) in project.rolls" :key="index">
              <td class="roll-title">
                <b>{{ roll.title }}</b>
              </td>
              <td class="roll-name" v-html="roll.name"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <projects-site></projects-site>
  </div>
</template>

<script>
export default {
  props: [
    'TogglePopup'
  ],
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  },
  computed: {
    projects() {
      return this.$store.state.projects;
    },
    activeProjects: function () {
      return this.$store.state.projects.filter((project) => {
        return project.path === this.$route.params.projName;
      });
    },
  },
  created() {
    this.$store.dispatch('initProjects');
  }
}
</script>

<style lang="scss">
.project-popup {
  display: flex;
  align-items: center;
  justify-content: center;

  .project-wrapper {
    width: 100vw;
    min-height: 100vh;
    margin-top: 8vh;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    background-blend-mode: lighten;
    display: flex;
    align-items: center;
    flex-direction: column;

    .background-img {
      position: fixed;
      z-index: 0;
      background-size: cover;
      background-position: center;
      filter: brightness(0.2);
      width: 100vw;
      height: 100vh;
    }

    .proj-content {
      width: 90vw;
      display: flex;
      align-items: center;
      flex-direction: column;
      z-index: 100;

      .proj-head {
        width: 50vw;
        display: flex;
        flex-direction: column;
        padding-top: 4rem;
        margin-bottom: 4rem;
        align-items: center;

        .back-button {
          font-family: "futura-pt";
          display: flex;
          justify-content: flex-start;
          position: fixed;
          cursor: pointer;
          width: 90vw;
        }

        a {
          font-size: 1.1rem;
          display: flex;
          justify-content: center;
          width: 9rem;
          height: 2.5rem;
          padding-top: 1.2rem;
          opacity: 0.5;
          border-radius: 0.3rem;
          transform: scale(1);
          transition-duration: 0.2s;

          &:hover {
            background-color: rgb(245, 244, 243, 0.1);
            transform: scale(1.03);
          }
        }

        h1 {
          font-size: 4rem;
          margin-top: 2rem;
          text-align: center;
          margin-bottom: 0;
        }

        .by {
          justify-content: center;
          margin: 0;

          p {
            padding-right: 0.2rem;
            margin: 0rem;
          }
        }
      }

      .sub-content {
        width: 50rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex-wrap: wrap;

        .placeholder {
          border-radius: 0;
          background-color: black;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1rem;

          p {
            position: absolute;
            z-index: 1;
          }

          iframe {
            width: 50rem;
            height: 3.125rem *9;
            border-radius: 0;
            z-index: 2;
          }
        }

        .proj-desc {
          max-width: 50rem;
          align-self: flex-start;
          display: flex;
          padding: 0;
          margin-bottom: 2vw;

          p {
            font-size: 0.8rem;
            text-transform: uppercase;
            text-align: left;
            line-height: 1.8 rem;
            margin-bottom: 2rem;
            margin-top: 2rem;
          }
        }

        table {
          font-family: "futura-pt";
          width: 30rem;
          align-self: flex-start;
          margin-bottom: 5vw;
          padding-right: 5rem;
          font-size: 0.8rem;
          color: white;
          z-index: 100;
          text-transform: uppercase;

          .roll-title {
            width: max-content;
            padding-right: 2rem;
          }

          a {
            font-size: 0.8rem;
            text-decoration: underline;
          }

          hl {
            text-decoration: underline #ffee00;
          }

          tr {
            vertical-align: top;
          }
        }
      }

    }
  }
}

@media only screen and (max-width: 1024px) {
  .project-popup {
    .project-wrapper {
      height: fit-content;
      padding-bottom: 5vh;

      .proj-content {
        width: 90vw;

        .proj-head {
          .back-button {
            opacity: 0;
          }

          h1 {
            font-size: 5vw;
            text-align: center;
          }

          .by {
            p {
              font-size: 2.5vw;
            }
          }

        }

        .sub-content {
          width: 100vw;
          align-items: center;
          justify-content: center;

          .placeholder {
            margin: 0;

            iframe {
              justify-self: center;
              width: 90vw;
              height: calc(90vw/16*9);
            }
          }

          .proj-desc {
            align-self: center;
            width: 90vw;
            padding: 2rem 0 2rem 0;
            border-radius: 0.3rem;
            font-size: 1.1rem;
            color: #f5f4f3;
            z-index: 100;

            p {
              text-align: left;
              line-height: 1.5rem;
            }
          }

          .rolls {
            align-self: center;
            width: 90vw;
            padding: 0;

            .roll-title {
              padding-right: 0;
            }
          }
        }
      }
    }
  }


}
</style>